<template>
    <div>
        <div v-if="!cargando">
            <div class="col-12" id="mapa">
                <template v-if="evento.place_obj.tipo_proceso_taquilla === 1">
                    <CleSvgComponent
                        v-if="zonas_formated.length > 0"
                        :zonas="zonas_formated"
                        :place="evento.place_obj"
                        :sesion_id="sesion_id"
                        :config_precios="false"
                        @clickZona="goTo" 
                    />
                </template>
                <template v-else>
                    <ul class="d-flex justify-content-center nav nav-pills">
                        <li class="nav-item">
                            <button
                                :class="tipo_regiones === 1 ? 'nav-link pe-auto active' : 'nav-link pe-auto'"
                                @click="() => this.tipo_regiones = 1"
                            >
                                Svg
                            </button>
                        </li>
                        <li class="nav-item">
                            <button
                                :class="tipo_regiones === 2 ? 'nav-link pe-auto active' : 'nav-link pe-auto'"
                                @click="() => this.tipo_regiones = 2"
                            >
                                Listado
                            </button>
                        </li>
                    </ul>
                    <hr/>
                    <SeccionesComponent
                        v-if="tipo_regiones === 1"
                        :event="evento"
                        :sesion_id="parseInt(sesion_id)"
                        @terminar="goTo(2, $event)"
                    />
                    <TablaSectoresComponent
                        v-else-if="tipo_regiones === 2"
                        :zonas="zonas_formated"
                        @goTo="goTo"
                    />
                </template>
                <h3 v-if="zonas && evento.place_obj.tipo_proceso_taquilla === 1">
                    <b>Libres: </b>
                    {{ total_libres }}
                </h3>
            </div>
            <div class="col-12" v-if="(configuracion.hash_teatro === 'MtDVv542o0x8qfp47N5p' && evento.place_obj.tipo_svg === 1) || evento.place_obj.tipo_proceso_taquilla === 1">
                <TablaSectoresComponent :zonas="zonas_formated" @goTo="goTo" />
            </div>
        </div>
        <div class="col-12" v-else>
            <LoaderComponent />
        </div>
    </div>
</template>

<script>
    import CleSvgComponent from '@/components/backend/stepper/components/CleSvgComponent';
    import TablaSectoresComponent from '@/components/backend/stepper/components/TablaSectoresComponent';
    import SeccionesComponent from '@/components/frontend/events/compra/components/secciones/SeccionesComponent';

    export default {
        props: ['evento', 'sesion_id', 'mode', 'asientos','datos_compradores', 'entradas', 'puede_cambiar'],
        data() {
            return {
                zonas: {},
                cargando: false,
                tipo_regiones: 1,
            }
        },
        created() {
            if(this.evento && this.evento.tiene_recinto && ((this.configuracion.hash_teatro === 'MtDVv542o0x8qfp47N5p' && this.evento.place_obj.tipo_svg === 1) || this.evento.place_obj.tipo_proceso_taquilla === 1 || this.evento.place_obj.tipo_proceso_taquilla === 2)) {
                this.getZonas();
            }            
        },
        computed: {
            total_libres() {
                let total = 0;

                if (this.zonas_formated && this.zonas_formated.length > 0) {
                    for (let i = 0; i < this.zonas_formated.length; i++) {
                        const zona = this.zonas_formated[i];
                        if (zona.name !== 'Internacional' && 
                            zona.name !== 'Baby' &&
                            zona.name !== 'internacional' &&
                            zona.name !== 'INTERNACIONAL' &&
                            zona.esta_disponible) {

                            let libres = 0;

                            if (zona.tiene_recinto) {
                                libres = zona.libres;
                            } else {
                                libres = zona.with_seats ? zona.total_asientos : zona.aforo;
                                libres = libres - zona.bloqueados - zona.confirmados - zona.no_confirmados - zona.sesion;   
                            }

                            total += libres;
                        }
                    }
                }

                return total;
            },
            zonas_formated() {
                let array = [];

                if(this.mode != 2) {
                    if(this.mode === 3) {
                        for(let zona_n in this.zonas) {
                            array.push(Object.assign({}, this.zonas[zona_n]));
                            let disponible_n = array[zona_n].esta_disponible && array[zona_n].precios_amigo_abonado?.length > 0 ? true : false;

                            array[zona_n].esta_disponible = disponible_n;
                        }
                    } else {
                        for(let zona_n in this.zonas) {
                            array.push(Object.assign({}, this.zonas[zona_n]));
                            let disponible_n = array[zona_n].precios.length > 0 && array[zona_n].esta_disponible ? true : false;
                            array[zona_n].esta_disponible = disponible_n;
                        }
                    }
                } else {
                    for(let zona in this.zonas) {
                        array.push(Object.assign({}, this.zonas[zona]));

                        array[zona].precios = Array.isArray(array[zona].precios_abonados) ? array[zona].precios_abonados : [];

                        let disponible = array[zona].precios.length > 0 && array[zona].esta_disponible ? true : false;
                        array[zona].esta_disponible = disponible;
                    }
                }

                return array;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            place() {
                return this.$store.getters.getRecinto;
            }
        },
        methods: {
            goTo(paso, zona) {
                if(this.mode === 2) {
                    let datos_compradores = this.datos_compradores;

                    datos_compradores.precios = zona.precios;

                    let abonado = {
                        dia_abonado: 1,
                        datos_compradores: datos_compradores,
                        entradas: this.entradas,
                        asientos: this.asientos,
                        puede_cambiar: this.puede_cambiar
                    }
                    this.$emit('goTo', paso, zona, abonado);

                } else {
                    this.$emit('goTo', paso, zona);
                }
            },
            getZonas() {
                this.cargando = true;
                let params = {
                    filters: {
                        evento_id: this.$route.params.evento_id,
                        sesion_id: this.$route.params.sesion_id
                    }
                };

                if(this.datos_compradores != undefined && this.datos_compradores[0]?.abonado_id) {
                    params.filters.abonado_id = this.datos_compradores[0].abonado_id;
                }

                if(this.datos_compradores != undefined && this.datos_compradores[0] != undefined && this.datos_compradores[0].id) {
                    params.filters.abonado_id = this.datos_compradores[0].id;
                }
            
                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.zonas = res.data;
                    if (this.place) {
                        this.getZonasAnexas();
                    } else {
                        this.cargando = false;
                    }
                    this.$emit('getZonasFormateadas', this.zonas_formated);

                });
            },
            getZonasAnexas() {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    recinto_id: this.place.id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.taquilla.recinto.zonas-anexas'), params).then(res => {
                    const zonasFormatted = this.zonas.filter(zona => zona.esta_disponible);
                    const zonasAnexasFormatted = res.data.data.filter(zonaAnexa => zonaAnexa.precios.length > 0);

                    if (zonasFormatted.length === 0 && zonasAnexasFormatted.length === 1) {
                        this.$emit('goTo', 2, zonasAnexasFormatted[0]);
                    }

                    this.zonas = this.zonas.concat(res.data.data);
                    this.$nextTick(() => {
                        this.$scrollTo('#mapa', 100);
                    })
                }).finally(() => this.cargando = false);
            },
        },
        components: {
            CleSvgComponent, TablaSectoresComponent, SeccionesComponent
        }
    }
</script>